import { EmailEspAccount } from 'modules/graphql/types';
import { Skeleton } from 'ui/skeleton';
import { EmailAccount } from './EmailAccount';
import { EmailAccountsEmptyState } from './EmailAccountsEmptyState';
import { SendingPlatform } from '../../../constants';
import { useSendingPlatformsQueryContext } from '../../../contexts';

export const EmailAccountsSection = ({ sendingPlatform }: { sendingPlatform: SendingPlatform }) => {
  const { espAccountsBySendingPlatform, isLoadingEssentialData } =
    useSendingPlatformsQueryContext();
  const espAccounts = espAccountsBySendingPlatform[sendingPlatform] || [];

  if (isLoadingEssentialData) return <Skeleton height={265} />;

  if (!espAccounts.length) return <EmailAccountsEmptyState sendingPlatform={sendingPlatform} />;

  return (
    <>
      {espAccounts.map((espAccount) => (
        <EmailAccount key={espAccount.id} espAccount={espAccount as EmailEspAccount} />
      ))}
    </>
  );
};
